import { useQuery } from '@tanstack/react-query';
import { getConfig } from '../tabs/api';

export const useGetConfig = (enabled: boolean = true) =>
  useQuery({
    queryKey: ['config'],
    queryFn: () => getConfig(),
    enabled,
  });
